import React, { useState } from "react";
import style from "../certificatePage/certificatePage.module.css";
import { useNavigate } from "react-router-dom";
import Table from "../../components/CommonComponents/Table/Table";
import PageHeader from "../../components/pageHeader/pageHeader";

const CertificatePage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const handleEntriesChange = (e: { target: { value: any; }; }) => {
    setEntriesPerPage(Number(e.target.value));
  };

  const navigate = useNavigate();

  const columns = [
    {
      name: 'Sr. No.',
      selector: (row: any, rowIndex: number | undefined) => ((rowIndex ?? 0) + 1),
      sortable: false,
    },
    {
      name: 'Certificate Name',
      selector: (row: any) => row.certificateName,
      sortable: true,
    },
    {
      name: 'Last Publish Date',
      selector: (row: any) => row.lastPublishDate,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row: any) => (
        <button
          className={
            row.status.toLowerCase() === "active"
              ? style.activeButton
              : style.inactiveButton
          }
        >
          {row.status}
        </button>
      ),
      sortable: true,
    },
    {
      name: 'Action',
      selector: (row: any) => (
        <button
          className={style.editButton}
        >
          Edit
        </button>
      ),
      sortable: false,
    },
  ];

  const tableData = [
    {
      srNo: 1,
      certificateName: "Certificate1",
      lastPublishDate: "06/12/2023",
      status: "Active"
    },
    {
      srNo: 2,
      certificateName: "Certificate2",
      lastPublishDate: "06/12/2023",
      status: "Inactive"
    },
    {
      srNo: 3,
      certificateName: "Certificate3",
      lastPublishDate: "06/12/2023",
      status: "Active"
    },
    {
      srNo: 4,
      certificateName: "Certificate4",
      lastPublishDate: "06/12/2023",
      status: "Inactive"
    },
    {
      srNo: 5,
      certificateName: "Certificate5",
      lastPublishDate: "06/12/2023",
      status: "Active"
    }

    // ... Add more rows as needed 
  ];

  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentTableData = tableData.slice(startIndex, endIndex);

  const generateTableRows = () => {
    return currentTableData
      .filter(
        (row) =>
          row.certificateName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.lastPublishDate.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.status.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .map((row, index) => (
        <tr key={index} className={index % 2 === 0 ? style.whiterow : style.greyrow}>
          <td>{row.srNo}</td>
          <td>{row.certificateName}</td>
          <td>{row.lastPublishDate}</td>
          <td>
            <button
              className={
                row.status === "Active" ? style.activebutton : style.inactivebutton
              }
            >
              {row.status}
            </button>
          </td>
          <td>
            <button className={style.editbutton}>Edit</button>
          </td>
        </tr>
      ));
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className={style.body}>
      {/* Main content here */}
      <div className={style.bodybox}>
        <PageHeader
          title="Certificate List"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={true}
          buttonTitle="Create Certificate"
        />
        <div className={style.verificationbox}>
          <div className={style.inputcontainertable}>
            {/* {table} */}
            <Table columns={columns} data={tableData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;
